import { Injectable } from '@angular/core';
import { ResourceHelperService } from '../resource-helper.service';

@Injectable({
  providedIn: 'root'
})
export class BalanceAdjustmentService {

  public balanceAdjustmentsResource: InterACT.Interfaces.IResource<InterACT.Interfaces.ChargeAccounts.BalanceAdjustmentsResponse>;
  public balanceAdjustmentResource: InterACT.Interfaces.IResource<InterACT.Interfaces.ChargeAccounts.BalanceAdjustmentResponse>;

  constructor(
    $resource: ng.resource.IResourceService,
    private resourceHelperService: ResourceHelperService) {
    this.balanceAdjustmentsResource = $resource('api/balance-adjustments',
      undefined,
      {
        save: {
          method: 'POST',
          headers: {
            'Access-Control-Expose-Headers': 'Location'
          },
          transformResponse: (data, headers) => {
            const response: any = {};
            response.data = data;
            (<any>response).headers = headers();
            return response;
          }
        }
      });
    this.balanceAdjustmentResource = $resource('api/balance-adjustments/:balanceAdjustmentId');
  }

  /**
   * A method that gets a list of balance adjustments using a given query.
   * 
   * @param page the number of records to retrieve
   * @param perPageCount the number of records to retrieve per page
   * @param query the query to use when querying the service
   */
  public getList(page: number, perPageCount: number, query: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, query);
    return <ng.IPromise<InterACT.Interfaces.ChargeAccounts.BalanceAdjustmentsResponse>>this.balanceAdjustmentsResource.get(options).$promise;
  }

  /**
   * A method that will create a balance adjustment with the provided data.
   * @param balanceAdjustment The BalanceAdjustment to create
   */
  public create(balanceAdjustment: InterACT.Interfaces.ChargeAccounts.BalanceAdjustment) {
    return this.balanceAdjustmentsResource.save(balanceAdjustment).$promise;
  }

  /**
   * Method that will get a balance adjustment.
   * @param id id of the balance adjustment to retrieve
   */
  public getBalanceAdjustment(id: string) {
    return this.balanceAdjustmentResource.get({ balanceAdjustmentId: id }).$promise;
  }
}
